// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__eYEfR","submitButton":"styles_submitButton__zGYtv"};